<template>
  <section>
    <MyNavBar :theme="theme" />
  </section>
  <section>
    <div class="about about1">
      <div>
        <h1 class="h1white">Conheça o BaObAH</h1>
        <p class="about1">
          Saiba mais sobre o nosso projeto e conheça a nossa equipe e<br />
          como nosso referatório pode te ajudar a encontrar <br />
          novos objetos de aprendizagem.
        </p>
      </div>
      <div>
        <img class="about1a" src="../../assets/logo-wrapper.png" alt="" />
      </div>
      <!--<div>
          <button type="button">Crie agora a sua conta gratuitamente</button>
          <a href="/login">Já possui uma conta? Faça o login aqui.</a>
        </div> -->
    </div>
    <div class="about2c">
      <div>
        <h1 class="about2a">Você conhece um baobá?</h1>
        <p class="about2">
          A Adansonia Digitata é uma árvore milenar encontrada originalmente no
          continente africano. A espécie tem como característica principal seu
          tronco bastante espesso e sua folhagem com formato parecido com
          digitais. Além disso, é uma árvore resistente e consegue armazenar
          para si uma quantidade enorme de água para sobreviver a tempos
        </p>
        <p class="about2">
          Por isso, nosso projeto ganhou muito mais sentido com esse nome, pois
          uniria a força, a resistência, a antiguidade e o digital em favor da
          História e de seu ensino no ciberespaço e nas escolas. Afinal, o que
          melhor do que remeter a uma espécie que inspira poesia, identidade,
          mitos e memória ancestral, para coligar a uma base que fomentará mais
          conhecimento de história pública para nossa comunidade? A nossa
          "árvore do mundo", para citar o filósofo romeno Mircea Eliade (2000),
          certamente nutrirá as novas gerações para um conhecimento histórico, a
          partir do espaço digital, impondo suas raízes de maneira sólida e
          consistente contra uma imensidão daninha de negação do passado.
        </p>
        <!-- <button type="button">Saiba mais</button> -->
      </div>
      <div class="about2b">
        <img src="../../assets/image1.png" alt="" />
      </div>
    </div>
  </section>
  <section>
    <div class="about3">
      <h1 class="about3b">
        O BaObAH é um <b class="about_title">referatório</b> de objetos digitais
        de aprendizagem<br />
        <b class="about3b"
          >conceitos históricos destinado a professores da Educação Básica.</b
        >
      </h1>
    </div>
    <hr class="line" />
    <div class="about3c">
      <p class="about3a">
        O objetivo do portal é identificar, catalogar e disponibilizar
        experiências diversas de produção, utilização e mixagem de materiais
        didáticos em formato digital para o Ensino de História. Nesse sentido,
        propõe-se a levantar, classificar e sistematizar Objetos de Aprendizagem
        (OA) que versem sobre o conhecimento histórico. A base
        teórica-metodológica que fundamenta as ações do repositório é a Didática
        da História, entendida como uma disciplina que utiliza de forma
        necessariamente interligada conhecimentos/conceitos/práticas de
        áreas/campos diferentes, aqui especialmente, historiografia, história
        escolar, história digital, Educação e estudos informacionais.
      </p>
      <p class="about3a">
        A proposta deste projeto é, por um lado, ampliar o rol de objetos
        disponíveis para professores do Ensino Fundamental e Médio, estudantes e
        pesquisadores das áreas de História e Educação. Em outra frente, visa
        examinar a experiência desses sujeitos utilizando o Baobah e os recursos
        disponíveis nele em atividades de ensino e aprendizagem de história, bem
        como seu papel como usuários que também inserem e classificam novos
        objetos de aprendizagem.
      </p>
      <p class="about3a">
        Para isso, o projeto também tem um caráter formador para uso em sala de
        aula e inserção de recursos na plataforma, seja a partir do próprio
        BaObAH, bem como de experiências prévias de criação e utilização de
        conteúdos históricos no universo digital.
      </p>
    </div>
  </section>
  <section class="about4a">
    <div class="about_title_a">
      <h1 class="h1white">Nossos Objetivos</h1>
    </div>
    <div class="about4">
      <div class="about4b">
        <div class="circle">1</div>
        <div class="text">
          A produção de um indexador de Objetos<br />
          Digitais de Aprendizagem de História para <br />
          educação básica.
        </div>
      </div>
      <div class="about4b">
        <div class="circle">2</div>
        <div class="text">
          Captar, classificar e sistematizar os<br />
          objetos de aprendizagem existentes na Internet<br />
          e outras mídias, referenciando<br />-os no portal.
        </div>
      </div>
      <div class="about4b">
        <div class="circle">3</div>
        <div class="text">
          Oferecer um banco de referências a<br />
          objetos com curadoria para uso na<br />
          educação básica.
        </div>
      </div>
      <div class="about4b">
        <div class="circle">4</div>
        <div class="text">
          Divulgar a base de dados específica de<br />
          História a estudantes de licenciatura e<br />
          docentes do Ensino Básico.
        </div>
      </div>
    </div>
  </section>
  <section id="publicacoes">
    <div class="topPC">
      <h1>Produções Científicas</h1>
      <h3>
        Explore publicações científicas sobre a plataforma, incluindo artigos e
        teses.
      </h3>
    </div>
    <div id="publi">
      <PublicacoesCard
        v-for="(publi, index) in publicacoes"
        :key="index"
        :title="publi.title"
        :autores="publi.autores"
        :resumo="publi.resumo"
        :palavrasChave="publi.palavrasChave"
        :link="publi.link"
      />
    </div>
  </section>

  <section>
    <MyFooter />
  </section>
</template>
<script>
import { defineComponent } from "vue";
import MyNavBar from "@/components/MyNavBar.vue";
import MyFooter from "@/components/MyFooter.vue";
import PublicacoesCard from "@/components/PublicacoesCard.vue";

export default defineComponent({
  name: "MyAbout",
  components: {
    MyNavBar,
    MyFooter,
    PublicacoesCard,
  },
  data() {
    return {
      theme: "light",
      publicacoes: [],
    };
  },
  async created() {
    try {
      const response = await fetch("/publicacoes.json");
      if (!response.ok) throw new Error("Erro ao carregar JSON");

      const data = await response.json();

      this.publicacoes = data;
    } catch (error) {
      console.error("Erro ao buscar JSON:", error);
    }
  },
});
</script>

<style lang="css" scoped>
* {
  color: var(--white);
}
#publicacoes {
  display: flex;
  margin-bottom: 32px;
  align-items: center;
}
.topPC h1 {
  font-family: DM Sans;
  font-weight: 700;
  font-size: 36px;
  line-height: 120%;
  letter-spacing: 0%;
  margin: 0;
}
.topPC h3 {
  font-family: DM Sans;
  font-weight: 300;
  font-size: 16px;
  line-height: 120%;
  letter-spacing: 0%;
}
.topPC {
  margin: 32px 0 40px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.h1white {
  color: white;
}
#publi {
  margin: 0 56px 0 80px;
  max-width: 1301px;
}
section {
  display: flex;
  flex-direction: column;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  color: black;
}
.about {
  /* margin: 10px; */
  display: flex;
  flex-direction: row;
  padding: 56px;
  gap: 30px;
  align-items: center;
}
.about1 {
  background-color: var(--terracota);
  text-align: justify;
  align-self: stretch;
  align-items: center;
  display: flex;
  justify-content: space-between;
  font: Roboto Slab;
}
.about1a {
  width: 405px;
  height: 250px;
  max-width: 100%;
}

.about2 {
  background-color: var(--white);
  color: var(--gray);
  font: Rubik;
  font-weight: 400;
  size: 16px;
  line-height: 26 px;
  text-align: justify;
  margin-left: 50px;
  margin-right: 50px;
  margin-bottom: 20px;
}
.about2a {
  background-color: var(--white);
  color: var(--terracota);
  font: Rubik;
  font-weight: 400;
  text-align: justify;
  margin-left: 50px;
}
.about2b {
  width: 50%;
  position: relative;
  margin-left: 0px;
  margin-right: 0px;
  margin-top: 0px;
  margin-bottom: 0px;
  object-fit: cover;
}
.about2c {
  /* margin: 10px; */
  display: flex;
  flex-direction: row;
  gap: 30px;
  align-items: center;
}

.about3 {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-top: 20px;
}
.about3a {
  background-color: var(--white);
  color: var(--gray);
  text-align: justify;
  font-weight: 400;
  font: Rubik;
  font-size: 16px;
  font-style: normal;
  line-height: normal;
  margin-top: 20px;
}

.about3b {
  background-color: var(--white);
  color: var(--orange);
  font: Roboto Slab;
  font-weight: 700;
  margin-bottom: 30px;
  text-align: center;
}
.about3c {
  margin-left: 50px;
  margin-right: 50px;
  margin-top: 20px;
  margin-bottom: 40px;
}
.about_title {
  background-color: var(--white);
  color: var(--terracota);
}

.about4 {
  background-color: #da872e;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  flex-direction: row;
}
.about4a {
  background-color: #da872e;
}
.about4b {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 0px;
  margin-bottom: 15px;
  margin-left: 10px;
  margin-right: 10px;
}
.about_title_a {
  background-color: #da872e;
  margin-left: 30px;
  margin-top: 5px;
  margin-bottom: 5px;
}
.circle {
  width: 75px;
  height: 75px;
  border-radius: 50%;
  background-color: #ffd340;
  color: #c66126;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px;
  font-size: 25px;
}
.text {
  font: Rubik;
  text-align: center;
  margin: 5px;
  font-size: 14px;
  font-weight: 400;
}

.line {
  border: none;
  border-top: 1px solid #c66126;
  margin-top: 0px;
  margin-bottom: 0px;
  margin-left: 250px;
  margin-right: 250px;
}

.about p,
h1 {
  /* margin-top: 30px; */
  margin-bottom: 30px;
}
</style>
